import { jsx as e, jsxs as o } from "react/jsx-runtime";
import { Link as p } from "react-router-dom";
import { B as w } from "./Button-1eab0617.js";
import { useState as C, useContext as v, useMemo as l } from "react";
import { Logo as d } from "./Logo.js";
import { D as N, b as y } from "./DarkModeSwitch.component-65f7aaab.js";
import { A as L } from "./Avatar.component-49c9cfc0.js";
const z = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "12",
    height: "7",
    viewBox: "0 0 12 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e("path", { d: "M0.366173 0.612999C0.561435 0.417737 0.878018 0.417737 1.07328 0.612999L5.41995 4.95967C5.73802 5.27774 6.26144 5.27774 6.57951 4.95967L10.9262 0.612999C11.1214 0.417737 11.438 0.417737 11.6333 0.612999C11.8285 0.808261 11.8285 1.12484 11.6333 1.32011L7.28661 5.66677C6.57802 6.37537 5.42144 6.37537 4.71284 5.66677L0.366173 1.32011C0.170911 1.12484 0.170911 0.808261 0.366173 0.612999Z" })
  }
), M = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "12",
    height: "7",
    viewBox: "0 0 12 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e("g", { transform: "matrix(-1,-1.22465e-16,1.22465e-16,-1,11.9994,6.66477)", children: /* @__PURE__ */ e("path", { d: "M0.366,0.613C0.561,0.418 0.878,0.418 1.073,0.613L5.42,4.96C5.738,5.278 6.261,5.278 6.58,4.96L10.926,0.613C11.121,0.418 11.438,0.418 11.633,0.613C11.829,0.808 11.829,1.125 11.633,1.32L7.287,5.667C6.578,6.375 5.421,6.375 4.713,5.667L0.366,1.32C0.171,1.125 0.171,0.808 0.366,0.613Z" }) })
  }
);
function D(r) {
  return r ? `Olá, ${r.split(" ")[0]}` : "Olá";
}
const u = {
  brand: "border-t-8 bg-lime-500 border-t-neutral-600  dark:bg-zinc-800 dark:border-t-lime-500",
  dark: "border-t-8 bg-zinc-800 border-t-lime-500",
  light: "border-t-8 border-b border-b-gray-200 bg-gray-50 border-t-lime-500 dark:bg-zinc-800 dark:border-t-lime-500 dark:border-b-0"
};
function B(r) {
  return (u[r || "light"] || u.light) + " flex items-center justify-between w-full h-24 px-6";
}
function A(r) {
  const t = " flex items-center h-10 px-3 py-2 ml-6 rounded-full leading-none text-center";
  return r === "brand" ? "bg-lime-600 text-zinc-800 dark:bg-neutral-600 dark:text-gray-50" + t : r === "dark" ? "bg-neutral-600 text-gray-50" + t : "bg-gray-200 text-zinc-800 dark:bg-neutral-600 dark:text-gray-50" + t;
}
function j(r) {
  return r === "dark" ? "text-white hover:text-zinc-100" : "text-zinc-800 hover:text-gray-700 dark:text-white dark:hover:text-zinc-100";
}
function O(r, t) {
  return r === "dark" || t === "dark" ? /* @__PURE__ */ e(d, { darkMode: !0, monochromatic: !0 }) : t === "brand" ? /* @__PURE__ */ e(d, { darkMode: !0 }) : /* @__PURE__ */ e(d, {});
}
function I(r) {
  const [t, h] = C(!1), { theme: s, darkModeProviderInstalled: g } = v(N), { moduleName: c, userName: n, onLogout: m } = r;
  let { color: a, darkModeSwitch: i = !0 } = r;
  a === "dark" && (i = !1), i && !g && (i = !1, console.error(
    "You are trying to use a dark mode switch, but <DarkModeProvider /> is not installed in your <App />."
  )), s === "dark" && (a = "dark");
  const f = l(() => B(a), [a]), b = l(() => j(a), [a]), x = l(() => O(s, a), [s, a]), k = l(() => A(a), [a]);
  return /* @__PURE__ */ o("div", { className: f, children: [
    /* @__PURE__ */ o("div", { className: "flex items-center", children: [
      /* @__PURE__ */ e(p, { to: "/", className: "block", children: /* @__PURE__ */ e("div", { className: "h-9", title: "Funcional Health Tech", children: x }) }),
      c ? /* @__PURE__ */ e("div", { className: k, children: /* @__PURE__ */ e("span", { children: c }) }) : null
    ] }),
    /* @__PURE__ */ o("div", { className: "flex items-center ml-8", children: [
      i ? /* @__PURE__ */ e(y, {}) : null,
      n ? /* @__PURE__ */ o(
        "div",
        {
          className: "ml-8 flex items-center justify-end max-w-xs truncate cursor-pointer " + b,
          onClick: () => h(!t),
          children: [
            /* @__PURE__ */ e(L, { name: n }),
            /* @__PURE__ */ e("div", { className: "ml-2 text-sm text-right ", children: D(n) }),
            /* @__PURE__ */ e("div", { className: "pl-2", children: t ? /* @__PURE__ */ e(M, {}) : /* @__PURE__ */ e(z, {}) })
          ]
        }
      ) : null
    ] }),
    n && t ? /* @__PURE__ */ o("div", { className: "absolute right-4 z-10 p-4 border border-gray-300 rounded shadow bg-gray-50 top-20 max-w-xs min-w-[150px] dark:bg-zinc-800", children: [
      /* @__PURE__ */ e("div", { className: "pb-2 font-bold capitalize dark:text-white", children: n }),
      m ? /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
        w,
        {
          color: "danger",
          size: "small",
          className: "w-full",
          onClick: () => m(),
          children: "sair"
        }
      ) }) : null
    ] }) : null
  ] });
}
export {
  I as UserBar
};
